// src/components/imagens/ImageComponent.js

import Logo from '../../imagens/logo.png'; 
import Banner from '../../imagens/banner.jpg'; 
import Banner2 from '../../imagens/banner2.jpg'; 
import Banner3 from '../../imagens/banner3.jpg'; 
import Minibanner from '../../imagens/minibanner.jpg'; 
import Minibanner2 from '../../imagens/minibanner2.jpg'; 
import Produto1 from '../../imagens/produtos/asa.jpg'; 
import Produto2 from '../../imagens/produtos/corteresf.jpg'; 
import Produto3 from '../../imagens/produtos/coxaesobreresf.jpg'; 
import Produto4 from '../../imagens/produtos/filédepeito.jpg'; 
import Produto5 from '../../imagens/produtos/frangoresf.jpg'; 
import Parceiro1 from '../../imagens/parceiros/Parceiro1.jpg'; 
import Parceiro2 from '../../imagens/parceiros/Parceiro2.jpg'; 
import Parceiro3 from '../../imagens/parceiros/Parceiro3.jpg'; 
import Parceiro4 from '../../imagens/parceiros/Parceiro4.jpg'; 
import Info1 from '../../imagens/info/info1.jpg'; 
import Info2 from '../../imagens/info/info2.jpg'; 
import Info3 from '../../imagens/info/info3.jpg'; 
import Info4 from '../../imagens/info/info4.jpg'; 
import Marca1 from '../../imagens/marcas/marca1.jpg'; 
import Marca2 from '../../imagens/marcas/marca2.jpg'; 
import Marca3 from '../../imagens/marcas/marca3.jpg'; 
import Marca4 from '../../imagens/marcas/marca4.jpg'; 
import Categoria1 from '../../imagens/categorias/categoria1.jpg';
import Categoria2 from '../../imagens/categorias/categoria2.jpg';
import Categoria3 from '../../imagens/categorias/categoria3.jpg';
import Categoria4 from '../../imagens/categorias/categoria4.jpg';
import Categoria5 from '../../imagens/categorias/categoria5.jpg';
import Categoria6 from '../../imagens/categorias/categoria6.jpg';
import Categoria7 from '../../imagens/categorias/categoria7.jpg';
import Categoria8 from '../../imagens/categorias/categoria8.jpg';
import Categoria9 from '../../imagens/categorias/categoria9.jpg';
import BannerCategoria1 from '../../imagens/categorias/bannercategorias/banner1.jpg';
import OfertasDaSemana from '../../imagens/ofertasdasemana.jpg'; 
import Food from '../../imagens/food.jpg'; 
import Churrasco from '../../imagens/churrasco.jpg'; 
import Variados from '../../imagens/variados.jpg'; 
import Frios from '../../imagens/frios.jpg';
import FriosELac from '../../imagens/frioselacticinios.jpg';
import DiaaDia from '../../imagens/diaadia.jpg';   
import Representante1 from '../../imagens/representante1.jpg'; 
import Representante2 from '../../imagens/representante.jpg';
import Setas from '../../imagens/setas.jpg';
import Maos from '../../imagens/maos.jpg';
import Eliandro from '../../imagens/eliandro.jpg';
import Eliandro2 from '../../imagens/eliandro2.jpg';
import Cidades from '../../imagens/cidades.jpg';
import ComoComprar1 from '../../imagens/comocomprar1.jpg';
import ComoComprar2 from '../../imagens/comocomprar2.jpg';
import ComoComprar3 from '../../imagens/comocomprar3.jpg';
import ComoComprar4 from '../../imagens/comocomprar4.jpg';
import ComoComprar5 from '../../imagens/comocomprar5.jpg';
import Receita1 from '../../imagens/receitas/receita1.jpg';
import Receita2 from '../../imagens/receitas/receita2.jpg';
import Receita3 from '../../imagens/receitas/receita3.jpg';
import Receita4 from '../../imagens/receitas/receita4.jpg';
import Cortes from '../../imagens/receitas/cortes.jpg';
import Dicas from '../../imagens/receitas/dica.jpg';
import Guias from '../../imagens/receitas/guias.jpg';
import BlogBanner from '../../imagens/receitas/blogbanner.jpg';
import CorteBovino from '../../imagens/receitas/cortebovino.jpg';
import Alcatra from '../../imagens/receitas/alcatra.jpg';
import MarcaBanner from '../../imagens/marcabanner.jpg';
import MarcaDesc from '../../imagens/marcadesc.jpg';
import ProdutoMarca1 from '../../imagens/produtos/produtomarca1.jpg';
import ProdutoMarca2 from '../../imagens/produtos/produtomarca2.jpg';
import ProdutoMarca3 from '../../imagens/produtos/produtomarca3.jpg';
import ProdutoMarca4 from '../../imagens/produtos/produtomarca4.jpg';
import ProdutoMarca5 from '../../imagens/produtos/produtomarca5.jpg';
import ProdutoMarca6 from '../../imagens/produtos/produtomarca6.jpg';
import ProdutoMarcaBanner from '../../imagens/produtos/produtomarcabanner.jpg';
import ProdutoMarcaConheca from '../../imagens/produtos/produtobannerconheca.jpg';

const Imagens = {
  Logo,
  Banner,
  Banner2,
  Banner3,
  Produto1,
  Produto2,
  Produto3,
  Produto4,
  Produto5,
  Parceiro1,
  Parceiro2,
  Parceiro3,
  Parceiro4,
  Minibanner,
  Minibanner2,
  Info1,
  Info2,
  Info3,
  Info4,
  Marca1,
  Marca2,
  Marca3,
  Marca4,
  Categoria1,
  Categoria2,
  Categoria3,
  Categoria4,
  Categoria5,
  Categoria6,
  Categoria7,
  Categoria8,
  Categoria9,
  BannerCategoria1,
  OfertasDaSemana,
  Food,
  Churrasco,
  Variados,
  Frios,
  FriosELac,
  DiaaDia,
  Representante1,
  Representante2,
  Setas,
  Maos,
  Eliandro,
  Eliandro2,
  Cidades,
  ComoComprar1,
  ComoComprar2,
  ComoComprar3,
  ComoComprar4,
  ComoComprar5,
  Receita1,
  Receita2,
  Receita3,
  Receita4,
  Cortes,
  Dicas,
  Guias,
  BlogBanner,
  CorteBovino,
  Alcatra,
  MarcaBanner,
  MarcaDesc,
  ProdutoMarca1,
  ProdutoMarca2,
  ProdutoMarca3,
  ProdutoMarca4,
  ProdutoMarca5,
  ProdutoMarca6,
  ProdutoMarcaBanner,
  ProdutoMarcaConheca 
};

export default Imagens;
